import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { ILogNote } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class LogNoteService extends BaseService<ILogNote> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'logNote');
  }

  postProcess(): (data: any) => any {
    return data => {
      if (Array.isArray(data)) {
        for (let d of data) {
          this.fixDate(d, 'date');
        }
      } else {
        this.fixDate(data, 'date');
      }
      return data;
    };
  }
}

export { ILogNote, LogNoteType, LogNoteNames } from '../shared/api';
